export default "__VITE_ASSET__BEGTwb5i__"